import React, { useEffect, useState } from "react";
import Logo from "@/components/Logo";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import api, { errText } from "@/lib/api";
import LoaderOlimpo from "@/components/LoaderOlimpo";
import { useAuth } from "@/context/AuthContext";

export default function Invitacion() {
  const { token } = useParams();
  const nav = useNavigate();
  const { register } = useAuth();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(false);
  const [nombre, setNombre] = useState("");
  const [password, setPassword] = useState("");
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/invitacion/${token}`);
        setInfo(data);
        // El nombre ya lo cargó el closer: viene precargado, la persona solo lo confirma o corrige.
        if (data?.nombre_persona) setNombre(data.nombre_persona);
      } catch {
        setError(true);
      }
    })();
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setCargando(true);
    try {
      await register(nombre, info.email, password);
      // Si el closer ya cargó todo (empresa, rubro, tamaño, rol), no pasa por /conocerte: directo a la mesa.
      nav(info.datos_completos ? "/" : "/conocerte");
    } catch (err) {
      toast.error(errText(err));
    } finally { setCargando(false); }
  };

  if (error) return (
    <div className="min-h-screen bg-negro flex items-center justify-center px-6 text-center">
      <div>
        <h1 className="titulo text-4xl mb-3">Este link no anda.</h1>
        <p className="text-gris">Pedile al equipo de Olimpo uno nuevo, o entrá con tu mail.</p>
      </div>
    </div>
  );

  if (!info) return <LoaderOlimpo fullscreen />;

  return (
    <div className="min-h-screen bg-negro flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="w-full max-w-md">
        <Logo variant="full" height={120} className="mb-12 mx-auto block" />
        <h1 className="titulo text-5xl mb-3">Bienvenido a {info.nombre}.</h1>
        <p className="text-gris mb-10">Confirmá tus datos, elegí una contraseña y arrancamos.</p>
        <form onSubmit={submit} className="space-y-4">
          <input className="input-dark" placeholder="¿Cómo te llamás?" value={nombre} onChange={(e) => setNombre(e.target.value)} required data-testid="inv-nombre" />
          <input className="input-dark opacity-60" value={info.email} disabled data-testid="inv-email" />
          <input className="input-dark" type="password" placeholder="Una contraseña" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="inv-password" />
          <button className="btn-dorado w-full mt-2" disabled={cargando} data-testid="inv-submit">{cargando ? "CREANDO…" : "EMPECEMOS"}</button>
        </form>
      </motion.div>
    </div>
  );
}
